import React, { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

import { Tab, Tabs, useTheme } from '@material-ui/core'

import { Container } from '../../components'
import { UnitInventoryHome } from '../Inspection/UnitInventory'
import { ProductLibraryHome } from '../Inspection/ProductLibrary'
import { typographyStyle } from '../../theme/typographyStyle'

const UNIT_INVENTORY_TAB = 0
const PRODUCT_LIBRARY_TAB = 1

const TabHashMap: { [key: number]: string } = {
    [UNIT_INVENTORY_TAB]: 'unit-inventory',
    [PRODUCT_LIBRARY_TAB]: 'product-library',
}

const BetaChip = () => {
    const theme = useTheme()
    return (
        <span
            style={{
                marginLeft: 8,
                padding: '2px 6px',
                borderRadius: 4,
                backgroundColor: '#FF6B35',
                color: theme.palette.common.white,
                fontSize: 10,
                fontWeight: 700,
                letterSpacing: 0.5,
                lineHeight: 1.2,
            }}
        >
            BETA
        </span>
    )
}

const tabLabel = (text: string) => (
    <span style={{ display: 'inline-flex', alignItems: 'center' }}>
        {text}
        <BetaChip />
    </span>
)

export const InventoryManagementRoot = () => {
    const theme = useTheme()
    const history = useHistory()
    const location = useLocation()

    const hashToTab = Object.fromEntries(
        Object.entries(TabHashMap).map(([key, value]) => [value, Number(key)]),
    )

    const [selectedTab, setSelectedTab] = useState(() => {
        const hash = location.hash.replace('#', '')
        return hash in hashToTab ? hashToTab[hash] : UNIT_INVENTORY_TAB
    })

    useEffect(() => {
        const hash = location.hash.replace('#', '')
        if (hash in hashToTab) {
            setSelectedTab(hashToTab[hash])
        }
    }, [location])

    const handleTabChange = (_: any, newValue: number) => {
        if (newValue !== selectedTab) {
            setSelectedTab(newValue)
            history.push(`/inventory-management#${TabHashMap[newValue]}`)
        }
    }

    return (
        <Container
            style={{
                flex: 1,
                flexDirection: 'column',
                height: 'calc(100vh - 104px)',
                overflowY: 'hidden',
                overflowX: 'auto',
                width: '100%',
            }}
        >
            <Tabs
                style={{
                    width: '100%',
                    backgroundColor: theme.palette.grey[300],
                    flexShrink: 0,
                }}
                value={selectedTab}
                onChange={handleTabChange}
                indicatorColor="primary"
                textColor="primary"
            >
                <Tab
                    label={tabLabel('Unit Inventory')}
                    style={{ textTransform: 'none', fontWeight: 600 }}
                />
                <Tab
                    label={tabLabel('Product Library')}
                    style={{ textTransform: 'none', fontWeight: 600 }}
                />
            </Tabs>
            <Container
                style={{
                    flexShrink: 0,
                    padding: theme.spacing(1, 2.5),
                    backgroundColor: '#FFF8E1',
                    borderBottom: '1px solid #FFE082',
                }}
            >
                <span
                    style={{
                        ...typographyStyle(theme.typography.body2),
                        color: '#8D6E00',
                    }}
                >
                    This feature is currently in beta. Inventory results may
                    need review before you rely on them.
                </span>
            </Container>

            {selectedTab === UNIT_INVENTORY_TAB && <UnitInventoryHome />}
            {selectedTab === PRODUCT_LIBRARY_TAB && <ProductLibraryHome />}
        </Container>
    )
}
